var map = {
	"./cocogoat/index.ts": [
		53042,
		[
			3042
		]
	],
	"./debug/index.ts": [
		32143,
		[
			2143
		]
	],
	"./onedrive/index.ts": [
		79256,
		[
			4893,
			9256
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 79868;
module.exports = webpackAsyncContext;